import { Stack, useLocalSearchParams } from 'expo-router';
import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useQuery } from 'urql';
import Box from '@/components/UI/Box';
import { graphql } from '@/gql/graphql';
import EventShareScheduleWidget from './components/EventShareScheduleWidget';

const GetEventShareSchedule = graphql(/* GraphQL */ `
  query GetEventShareSchedule($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      title
    }
  }
`);

export default function EventShareSchedule() {
  const { eventId } = useLocalSearchParams<{
    eventId?: string;
  }>();

  const [{ data }] = useQuery({
    query: GetEventShareSchedule,
    variables: {
      eventId: eventId!,
    },
  });

  return (
    <ScrollView contentContainerStyle={style.scrollView}>
      <Stack.Screen options={{ title: data?.event_by_pk?.title || '' }} />
      <Box space="lg" p="lg" alignItems="center">
        <EventShareScheduleWidget />
      </Box>
    </ScrollView>
  );
}

const style = StyleSheet.create((_, rt) => ({
  scrollView: {
    paddingBottom: rt.insets.bottom,
  },
}));
